document.querySelector(".popup-custom-btn").addEventListener('click', function (e) {
  e.stopPropagation();
  document.querySelector(".popup-custom").style.display = 'block';
}, false);
document.querySelector(".popup-custom-btn").addEventListener('click', function () {
  document.querySelector(".popup-custom-overlay").style.display = 'block';
}, false);
document.querySelector(".popup-custom-close").addEventListener('click', function () {
  document.querySelector(".popup-custom").style.display = 'none';
  document.querySelector(".popup-custom-overlay").style.display = 'none';
}, false);
document.querySelector("body").addEventListener('click', function () {
  document.querySelector(".popup-custom").style.display = 'none';
  document.querySelector(".popup-custom-overlay").style.display = 'none';
}, false);
document.querySelector(".popup-custom").addEventListener('click', function (e) {
  e.stopPropagation();
}, false);

var but = document.querySelector(".popup-custom-btn");
setTimeout(function () {but.click();},3000);